"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var superagent_1 = __importDefault(require("superagent"));
var appConfig_1 = __importDefault(require("../config/appConfig"));
var OFFERS_ENDPOINT = "/api/offers";
var PURCHASE_ENDPOINT = "/api/purchase";
var PURCHASE_STATUS_ENDPOINT = "/api/purchase/status";
var SESSION_ID_HEADER = "X-Session-ID";
var API_BASE_URL = appConfig_1.default.getApiBaseUrl();
var buildApiUrl = function (endpoint) {
    var baseUrl = (API_BASE_URL === null || API_BASE_URL === void 0 ? void 0 : API_BASE_URL.trim()) || "";
    if (!baseUrl) {
        return endpoint;
    }
    var normalizedBase = baseUrl.replace(/\/+$/, "");
    return "".concat(normalizedBase).concat(endpoint);
};
var getResponseBody = function (response) {
    if (response.body && typeof response.body === "object") {
        return response.body;
    }
    if (typeof response.text === "string") {
        try {
            return JSON.parse(response.text);
        }
        catch (_a) {
            return null;
        }
    }
    return null;
};
var getOffers = function (sessionId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, body, payload;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .get(buildApiUrl(OFFERS_ENDPOINT))
                    .set(SESSION_ID_HEADER, sessionId)
                    .timeout({ response: 3000, deadline: 5000 })];
            case 1:
                response = _b.sent();
                body = getResponseBody(response);
                payload = (_a = body === null || body === void 0 ? void 0 : body.data) !== null && _a !== void 0 ? _a : body;
                if (Array.isArray(payload === null || payload === void 0 ? void 0 : payload.offers)) {
                    return [2 /*return*/, {
                            offers: payload.offers
                        }];
                }
                throw new Error("Offer API returned invalid offers payload");
        }
    });
}); };
var purchaseOffers = function (payload, sessionId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, status;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .post(buildApiUrl(PURCHASE_ENDPOINT))
                    .set(SESSION_ID_HEADER, sessionId)
                    .send(payload)
                    .timeout({ response: 3000, deadline: 5000 })];
            case 1:
                response = _g.sent();
                status = (_a = response.body) === null || _a === void 0 ? void 0 : _a.status;
                if (status === "pending" || status === "success" || status === "failed") {
                    return [2 /*return*/, {
                            status: status,
                            orderId: (_b = response.body) === null || _b === void 0 ? void 0 : _b.orderId,
                            paymentUrl: (_c = response.body) === null || _c === void 0 ? void 0 : _c.paymentUrl,
                            expiresAt: (_d = response.body) === null || _d === void 0 ? void 0 : _d.expiresAt,
                            reason: (_e = response.body) === null || _e === void 0 ? void 0 : _e.reason,
                            tickets: Array.isArray((_f = response.body) === null || _f === void 0 ? void 0 : _f.tickets)
                                ? response.body.tickets
                                : undefined
                        }];
                }
                throw new Error("Purchase API returned invalid purchase status");
        }
    });
}); };
var getPurchaseStatus = function (orderId, sessionId) { return __awaiter(void 0, void 0, void 0, function () {
    var response, status;
    var _a, _b, _c, _d, _e, _f;
    return __generator(this, function (_g) {
        switch (_g.label) {
            case 0: return [4 /*yield*/, superagent_1.default
                    .get(buildApiUrl(PURCHASE_STATUS_ENDPOINT))
                    .set(SESSION_ID_HEADER, sessionId)
                    .query({ orderId: orderId })
                    .timeout({ response: 3000, deadline: 5000 })];
            case 1:
                response = _g.sent();
                status = (_a = response.body) === null || _a === void 0 ? void 0 : _a.status;
                if (status === "pending" || status === "success" || status === "failed") {
                    return [2 /*return*/, {
                            status: status,
                            orderId: (_b = response.body) === null || _b === void 0 ? void 0 : _b.orderId,
                            paymentUrl: (_c = response.body) === null || _c === void 0 ? void 0 : _c.paymentUrl,
                            expiresAt: (_d = response.body) === null || _d === void 0 ? void 0 : _d.expiresAt,
                            reason: (_e = response.body) === null || _e === void 0 ? void 0 : _e.reason,
                            tickets: Array.isArray((_f = response.body) === null || _f === void 0 ? void 0 : _f.tickets)
                                ? response.body.tickets
                                : undefined
                        }];
                }
                throw new Error("Purchase status API returned invalid purchase status");
        }
    });
}); };
var offerApi = {
    getOffers: getOffers,
    purchaseOffers: purchaseOffers,
    getPurchaseStatus: getPurchaseStatus
};
exports.default = offerApi;
